import { SupplierCommissionMap } from './supplier-commission-map';

export class SupplierCommissionReportGroup {

	public id: number;
	public supplierId: string;
	public name: string;

	public isDefaultMapping = false;	//Mapping group with mapping with no assigned SupplierCommissionReportGroup
	public supplierCommissionMaps: SupplierCommissionMap[];

	constructor(supplierCommissionReportGroup?: SupplierCommissionReportGroup) {
		Object.assign(this, supplierCommissionReportGroup);

		this.supplierCommissionMaps = this.supplierCommissionMaps
			? this.supplierCommissionMaps.map(b => new SupplierCommissionMap(b))
			: this.supplierCommissionMaps;
	}
}
